import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Droppable } from "react-beautiful-dnd";
import { Col, Card, Modal } from 'react-bootstrap';
import { isUUID, searchWord, isToday, usePermission } from '../../../helpers/common';
import OptionCard from './EquipmentCard';
import { setFilterList } from '../../../actions/eg-kanban';
import { EG_OPTION_TYPES } from '../../../constants';
import { EGKanbanContext } from '../Context/EGKanbanContext';
import OperatorForm from '../Form/OperatorForm';
import EquipmentForm from '../../equipment/EquipmentForm';
import { SubNav } from '../../layout/submenu';
import DeviceForm from '../Form/DeviceForm';

const IconUrl = {
    "vehicle": "fa fa-truck",
    "implement": "fa fa-link",
    "device": "fa fa-mobile",
    "operator": "fa fa-user"
}

const EquipmentColumn = (props) => {
    const { isRequestingEg, type, farmId, draggableType, refresh, info,
        egListById, newEgList, kanban, kanbanInfo, search, actions, deviceList } = props;
    const [isDropDisabled, setDropDisable] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showAllDevice, setShowAllDevice] = useState(false);
    const context = useContext(EGKanbanContext);

    const handleModalClose = () => setShowModal(false);

    useEffect(() => {
        context.eventEmitter.addListener("@kanban/change_searchtext", props.type, text => setSearchText(text));
        return () => context.eventEmitter.removeListenerByName(props.type);
    }, [isRequestingEg]);

    useEffect(() => {
        const egOptionTypes = Array.from(EG_OPTION_TYPES);
        if (draggableType) {
            egOptionTypes.splice(egOptionTypes.indexOf(type), 1);
            setDropDisable(egOptionTypes.indexOf(draggableType) >= 0)
        }
    }, [draggableType])

    useEffect(() => {
        const typeIndex = EG_OPTION_TYPES.indexOf(type);

        const previousAssignedList = [];
        const newAssignedList = [];
        for (const id in egListById) {
            const oldList = egListById[id].list ? egListById[id].list : ["", "", "", ""];
            const newList = kanban.hasOwnProperty(id) && kanban[id].list ? kanban[id].list : ["", "", "", ""];

            const oldTypeId = oldList[typeIndex];
            const newTypeId = kanban.hasOwnProperty(id) ? newList[typeIndex] : oldList[typeIndex];

            if (isUUID(oldTypeId)) previousAssignedList.push(oldTypeId);
            if (isUUID(newTypeId)) newAssignedList.push(newTypeId);
        }

        newEgList.forEach(item => {
            const id = item.equipment_group_uuid;
            if (kanban.hasOwnProperty(id)) {
                const list = kanban[id].list ? kanban[id].list : ["", "", "", ""];
                const typeId = list[typeIndex];
                if (isUUID(typeId)) newAssignedList.push(typeId);
            }
        });

        const prevFilterList = Object.keys(info.listById).filter(id => previousAssignedList.indexOf(id) < 0);
        const newFilterList = Object.keys(info.listById).filter(id => newAssignedList.indexOf(id) < 0);
        actions.setFilterList({ optionType: type, oldFilterData: prevFilterList, newFilterData: newFilterList });

    }, [isRequestingEg === false, info.isRequesting === false, refresh]);

    const allow = usePermission();
    let isAllowAdd = false;
    if (props.type === "operator")
        isAllowAdd = allow("operator", "create") ? isToday(search.range) : false;
    else if (props.type === "vehicle" || props.type === "implement")
        isAllowAdd = allow("equipment", "create") ? isToday(search.range) : false;
    else if (props.type === "device")
        isAllowAdd = allow("device", "create") ? isToday(search.range) : false;

    const haveAddButton = isAllowAdd;

    let optionList = kanbanInfo.list;
    if (type === "device" && !showAllDevice) {
        const activeDeviceIds = deviceList.filter(item => item.is_active).map(item => item.device_uuid);
        optionList = optionList.filter(item => activeDeviceIds.indexOf(item) >= 0);
    }

    return <><Card className={`h-100 options-container ${type}`}>
        <Card.Header className={`p-0 option-header ${type}`}>
            <Card.Title className="option-title">
                <i className={`${IconUrl[props.type]} img-type`} aria-hidden="true"></i>
                <span className="name">{kanbanInfo.title}</span>
                {haveAddButton && <span className="add-btn" onClick={() => setShowModal(true)}><i className="fa fa-plus-circle" title={kanbanInfo.addTitle} aria-hidden="true"></i></span>}
                {props.type === 'device' && <span>
                    <span
                        className="toggle-btn"
                        title={!showAllDevice ? "Include inactive devices" : "Exclude inactive devices"}>
                        <SubNav.Checkbox className="device-show-all" onChange={(e) => setShowAllDevice(e.target.checked)} />
                    </span>
                    <span className="toggle-btn-name">Show all</span>
                </span>}
            </Card.Title>
        </Card.Header>
        <Card.Body className="p-1 option-body">
            {info.isRequesting && <Col className="text-center mt-3">Loading...</Col>}
            {!info.isRequesting && <Droppable
                droppableId={type} isDropDisabled={isDropDisabled}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        className={`kanban-option-body`} >
                        {optionList.map((id, i) => (
                            <OptionCard key={id} type={type} id={id} index={i}
                                onSearchFilter={e => searchWord(e, searchText)} />
                        ))}
                        {provided.placeholder}
                    </div>)}
            </Droppable>}
        </Card.Body>
    </Card>
        {showModal && ["vehicle", "implement"].indexOf(props.type) >= 0
            ? <Modal show={showModal} onHide={handleModalClose} backdrop="static" className="equipment-modal-form">
                <EquipmentForm isModalType={true} onHide={handleModalClose} farmId={farmId} equipmentType={props.type} />
            </Modal>
            : ["device"].indexOf(props.type) >= 0
                ? <DeviceForm show={showModal} onHide={handleModalClose} />
                : <OperatorForm show={showModal} onHide={handleModalClose} />}
    </>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        setFilterList
    }, dispatch)
});

const mapStateToProps = (state, ownProps) => ({
    isRequestingEg: state.egKanban.isRequestingEg,
    farmId: state.egKanban.filters.farmId,
    refresh: state.egKanban.refresh,
    info: state.egKanban.optionList[ownProps.type],
    deviceList: state.egKanban.optionList[ownProps.type].list,
    egListById: state.egKanban.egListById,
    kanban: state.egKanban.kanban,
    kanbanInfo: state.egKanban.kanban[ownProps.type],
    newEgList: state.egKanban.newEgList,
    search: { range: state.analyze.searchParams.range }
});

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentColumn);